import { render, staticRenderFns } from "./userAgency.vue?vue&type=template&id=e27d6776&scoped=true&"
import script from "./userAgency.vue?vue&type=script&lang=js&"
export * from "./userAgency.vue?vue&type=script&lang=js&"
import style0 from "./userAgency.vue?vue&type=style&index=0&id=e27d6776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27d6776",
  null
  
)

export default component.exports